import { render, staticRenderFns } from "./sso-login.vue?vue&type=template&id=a1bd2558"
import script from "./sso-login.vue?vue&type=script&lang=js"
export * from "./sso-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports